/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Sos_Without_SeasonInputs */

const en_queue_sos_without_season = /** @type {(inputs: Queue_Sos_Without_SeasonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales orders without a season`)
};

/**
* | output |
* | --- |
* | "Sales orders without a season" |
*
* @param {Queue_Sos_Without_SeasonInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_sos_without_season = /** @type {((inputs?: Queue_Sos_Without_SeasonInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Sos_Without_SeasonInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_sos_without_season(inputs)
});